<template>
	<div class="">

    <template v-if="!showReport">
			<div class="pg_sec reports_container">

	      <div class="row">
					<div class="col-12">
						<div class="reports_filter margin-right-40">
	            <template>
	              <b-link @click="changeTimePeriod('all')" :class="isAllActive">All</b-link> |
	              <b-link @click="changeTimePeriod('60')" :class="is60Active">Last 60 days</b-link> |
	              <b-link @click="changeTimePeriod('30')" :class="is30Active">Last 30 days</b-link> |
	              <b-link @click="changeTimePeriod('7')" :class="is7Active">Last Week</b-link>
	            </template>
	          </div>
	          <div class="reports_filter">
							<b-btn class="btn_ic ace_sec" aria-label="filters" id="popover_reportsFilters" @click="openReportFilterPopup">
								<span class="ic ic-filter"></span>
							</b-btn>
						</div>
					</div>

					<b-popover ref="reportsFiltersPopup" target="popover_reportsFilters" :show.sync='showFilter' placement="bottom" class="chart_tooltip_popover" container="reportsFiltersContainer">
						<div class="popup_hd row">
							<div class="hd_txt col-11">
								Filters
							</div>
							<div class="btn_container col-1">
								<button class="btn_close" aria-label="close" @click="closeReportsFiltersPopup">
									<span class="ic-close"></span>
								</button>
							</div>
						</div>
						<div class="row popup_content">
							<div class="col-12">

								<div class="popup_content_row">
			          	<input type="checkbox" :checked="showActivityReports" v-model="showActivityReports"></input>
			          	<span>Activity Reports</span>
								</div>
				        <div class="popup_content_row">
				          <input type="checkbox" :checked="showEngagementReports" v-model="showEngagementReports"></input>
									<span>Engagement Reports</span>
								</div>
				        <div class="popup_content_row">
				          <input type="checkbox" :checked="showInterestReports" v-model="showInterestReports"></input>
				          <span>Interest Reports</span>
				        </div>

							</div>
						</div>
					</b-popover>
					<div id="reportsFiltersContainer" class="chart_tooltip_popover"></div>
				</div>

	      <template v-if="showActivityReports && activityReports.length > 0">
					<div class="row report_block">
						<div class="col-12">
							<div class="row">

								<div class="col-12 hd ace_sec_hd">
			  					<h2>Activity</h2>
			  					<span class="hd_bdr"></span>
			  				</div>

								<div class="col-6" v-for="(c, index) in activityReports">
			  					<div class="row sec_report" v-if="c.type !== 'compare'">
			  						<div class="col-12 hd ace_sec_hd" :aria-label="c.title">
			  							<span class="hd_txt" @click="changeReport(c)">{{c.title}}</span>
			  						</div>
			  						<div class="col-12 report_sec_block">
			  							<report :selectedReport="c" :type="c.visualizationType" :timeperiod="timeperiodSelected" :isAdvisor="isAdvisor" :adviseeName="adviseeName"></report>
			  						</div>
			  					</div>
									<div class="row lnk_sec" v-if="c.type !== 'compare'">
										<div class="col-12">
											<b-link @click="changeReport(c)">more</b-link>
										</div>
									</div>
			  				</div>

							</div>
						</div>
					</div>
        </template>

        <template v-if="showEngagementReports && engagementReports.length > 0">
					<div class="row report_block">
						<div class="col-12">
							<div class="row">

			  				<div class="col-12 hd ace_sec_hd">
			  					<h2>Engagement</h2>
			  					<span class="hd_bdr"></span>
			  				</div>

			    			<div class="col-6 engagement_report" v-for="(c, index) in engagementReports">
									<div class="row sec_report" v-if="c.type !== 'compare'">
			  						<div class="col-12 hd ace_sec_hd" :aria-label="c.title">
			  							<span class="hd_txt" @click="changeReport(c)">{{c.title}}</span>
			  						</div>
			  						<div class="col-12 report_sec_block">
			  							<report :selectedReport="c" :type="c.visualizationType" :timeperiod="timeperiodSelected" :isAdvisor="isAdvisor" :adviseeName="adviseeName"></report>
			  						</div>
			  					</div>
									<div class="row lnk_sec" v-if="c.type !== 'compare'">
										<div class="col-12">
											<b-link @click="changeReport(c)">more</b-link>
										</div>
									</div>
			  				</div>

							</div>
						</div>
					</div>
        </template>

        <template v-if="showInterestReports && interestReports.length > 0">
					<div class="row report_block">
						<div class="col-12">
							<div class="row">

			  				<div class="col-12 hd ace_sec_hd">
			  					<h2>Interest</h2>
			  					<span class="hd_bdr"></span>
			  				</div>

			  				<div class="col-6 sec_report_interest" v-for="(c, index) in interestReports" @click="changeReport(c)">
			  					<div class="row sec_report">
										<div class="col-12 hd ace_sec_hd" :aria-label="c.title">
			  							<span>{{c.title}}</span>
			  						</div>
			  						<div class="col-12 report_content" v-if="c.visualizationType === 'compare'">
			  							<report-compare :isProgram="c.title === 'Total Program Views'" :isAdvisor="isAdvisor" :adviseeName="adviseeName"></report-compare>
			  						</div>
			              <div class="col-12 report_content" v-if="c.visualizationType !== 'compare'">
			  							<report :selectedReport="c" :type="c.visualizationType" :timeperiod="timeperiodSelected" :isAdvisor="isAdvisor" :adviseeName="adviseeName"></report>
			  						</div>
			  					</div>
									<!--
									<div class="row lnk_sec" v-if="c.type !== 'compare'">
										<div class="col-12">
											<b-link @click="changeReport(c)">more</b-link>
										</div>
									</div>
									-->
			  				</div>

							</div>
						</div>
					</div>
        </template>

				<template v-if="!showActivityReports && !showEngagementReports && !showInterestReports">
					<div class="msg_no_data">
						No report selected from filter
					</div>
				</template>

	    </div>
    </template>

    <template v-if="showReport">
			<div class="pg_sec reports_container" style="padding-bottom: 0; margin-bottom: 0px;">

	      <div class="row detail_report sec_report">

					<div class="col-12 hd ace_sec_hd" aria-label="Experience">
						<div class="row hd_sec" style="max-width: calc(100% - 1px);">
							<div class="col-8">
								<span><b-link @click="showAllReports()">Reports</b-link> / {{selectedReport.title}}</span>
							</div>
							<div class="col-4 lnk_sec pr-0">
								<download-csv role="button" class="ace_sec tbl_lnk" :data="selectedReportDataForCSV" :name="selectedReport.title + '.csv'">Export as CSV</download-csv>
							</div>
						</div>
	        </div>

	        <div class="col-12 list_view ace_sec" aria-label="Certifications Chart">
						<template v-if="selectedReport.type !== 'compare' && selectedReport.visualizationType !== 'table'">
							<div class="report_filter">
	              <b-link @click="changeTimePeriod('all')" :class="isAllActive">All</b-link> |
	              <b-link @click="changeTimePeriod('60')" :class="is60Active">Last 60 days</b-link> |
	              <b-link @click="changeTimePeriod('30')" :class="is30Active">Last 30 days</b-link> |
	              <b-link @click="changeTimePeriod('7')" :class="is7Active">Last Week</b-link>
								</div>
            </template>
	          <report v-if="selectedReport.type !== 'compare'" :selectedReport="selectedReport" :type="selectedReport.visualizationType" :timeperiod="timeperiodSelected" :isAdvisor="isAdvisor" :adviseeName="adviseeName"></report>
	          <report-compare v-if="selectedReport.type === 'compare'" :isProgram="selectedReport.isProgram" :isAdvisor="isAdvisor" :adviseeName="adviseeName"></report-compare>
	        </div>
	      </div>

			</div>
    </template>

	</div>
</template>
    <div class="modal_container modal_alart">
      <b-modal class="" ref="errorModal" :title="'Error Message!'" :header-bg-variant="'competency-upload-exists-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
          <div class="text-center">
            <span > No Data available to export !</span>
          </div>
        <div slot="modal-header" class="header-section">
          <div class="ic ic-hd"></div>
          <div class="head_txt">Error Message!</div>
          <button type="button" class="btn_close" @click="hideErrorModal" aria-label="close">
            <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
            <b-button @click="hideErrorModal" class="btn button-primary float-right mr-2" aria-label="no"> ok </b-button>
        </div>
      </b-modal>
    </div>
<script>
import { mapState, mapActions } from 'vuex'
import DateRangePicker from 'vue2-daterange-picker'
import Report from './Report'
import ReportCompare from './ReportCompare'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: 'reportList',
  props: ['isAdvisor', 'adviseeName', 'adviseeUuid', 'adviseeRole'],
  components: {
    Report,
    ReportCompare,
    DateRangePicker
  },
  data: () => {
    return {
      showReport: false,
      userrole: localStorage.getItem('userrole'),
      showActivityReports: true,
      showEngagementReports: true,
      showInterestReports: true,
      timeperiodSelected: '60',
      firstDay: 0,
      userReports: [],
      selectedReport: {},
      showFilter: false,
      showError:false
    }
  },
  mounted () {
    this.loadReportList()
  },
  methods: {
    ...mapActions([
      'loadReportQuery',
      'loadUserReports',
      'loadUserReportsByRole'
    ]),
    async loadReportList () {
      this.userReports = []
      if (this.isAdvisor) {
        if (this.adviseeUuid) {
          this.userReports = await this.loadUserReportsByRole({role: this.adviseeRole, userUuid: this.adviseeUuid})
        }
      } else {
        this.userReports = await this.loadUserReports()
      }
    },
    changeTimePeriod (timeperiod) {
      this.timeperiodSelected = timeperiod
    },
    showAllReports () {
      this.selectedReport = {}
      this.showReport = false
    },
    hideErrorModal () {
    	this.$refs.errorModal.hide()
    },
    changeReport (report) {
      if (report.visualizationType !== 'compare') {
        this.selectedReport = report
        this.showReport = true
      }
    },
    setTitleBoxWidth (entityTitle, entityId) {
      let getTitleInitials = entityTitle.match(/\b(\w)/g)
      if (getTitleInitials.length < 3) {
        $('#' + entityId).addClass('txt_bx_' + getTitleInitials.length)
      }
      return entityId
    },
    setTitleInitials (entityTitle) {
      let getTitleInitials = entityTitle.match(/\b(\w)/g)
      return getTitleInitials.join('')
    },
    updateTitleHeight (index) {
      let titleContainerHeight = $('#entityName_' + index).height()
      if (titleContainerHeight > 30) {
        $('#entityDesc_' + index).addClass('srt_desc')
      }
    },
    closeReportsFiltersPopup () {
      this.showFilter = false
      this.$refs.reportsFiltersPopup.$emit('close')
    },
    openReportFilterPopup () {
      this.showFilter = true
    }
  },
  computed: {
    ...mapState({
      'userObj': state => state.user.userObj
    }),
    isAllActive () {
      if (this.timeperiodSelected === 'all') {
        return 'active'
      }
      return ''
    },
    is60Active () {
      if (this.timeperiodSelected === '60') {
        return 'active'
      }
      return ''
    },
    is30Active () {
      if (this.timeperiodSelected === '30') {
        return 'active'
      }
      return ''
    },
    is7Active () {
      if (this.timeperiodSelected === '7') {
        return 'active'
      }
      return ''
    },
    activityReports () {
      if (this.userReports.length > 0) {
        let activityReports = []
        this.userReports.forEach((item, i) => {
          if (item.type === 'Activity') {
            activityReports.push(item)
          }
        })
        return activityReports
      } else {
        return []
      }
    },
    engagementReports () {
      if (this.userReports.length > 0) {
        let activityReports = []
        this.userReports.forEach((item, i) => {
          if (item.type === 'Engagement') {
            activityReports.push(item)
          }
        })
        return activityReports
      } else {
        return []
      }
    },
    interestReports () {
      if (this.userReports.length > 0) {
        let activityReports = []
        this.userReports.forEach((item, i) => {
          if (item.type === 'Interest') {
            activityReports.push(item)
          }
        })
        return activityReports
      } else {
        return []
      }
    },
    selectedReportDataForCSV () {
      let data = {

      }
      if (this.selectedReport && this.selectedReport.visualizationType === 'table') {
        data = JSON.parse(this.selectedReport.description)
      }else{
      	data = this.selectedReport.data
	  		if(this.timeperiodSelected === '60'){
	  				data = this.selectedReport.data60
	  		}else if(this.timeperiodSelected === '30'){
	  				data = this.selectedReport.data30
	  		}else if(this.timeperiodSelected === '7'){
	  				data = this.selectedReport.data7
	  		}

      }
      if(!data || data.length==0){
      	data[0] = {'key' : 'No data', 'value':'No Data available to export'}
      }
      return data
    }

  },
  watch: {
    adviseeUuid (newAdviseeUuid) {
      // this.loadReportList()
    }
  }
}
</script>
<style>
.active {
  cursor: default;
}
.margin-right-40 {
  margin-right: 40px!important;
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/ReportList.vue